import { getToLocalStorage } from "./index";

export const isAuth = () => {
  const isAuthenticated = getToLocalStorage("isAuthenticated");
  return !!isAuthenticated;
};
